import React from "react";
import * as Middleware from "@middlewares/index";
import Connector from "@helpers/Connector";
import { InputAutocomplete } from "@components/form/index";
import * as Type from "@interface/index";

interface PropsInterface extends Type.ComponentInterface {
  callback: (company_id: number) => void;
}

interface StateInterface {
  company_id: number | null;
}

export default Connector(
  class SelectCompany extends React.Component<PropsInterface, StateInterface> {
    public constructor(props: PropsInterface) {
      super(props);
      this.state = {
        company_id: null,
      };
      this.onSubmitHandler = this.onSubmitHandler.bind(this);
      this.onSelectHandler = this.onSelectHandler.bind(this);
    }

    private onSubmitHandler(event: React.FormEvent<HTMLFormElement>): void {
      event.preventDefault();
      this.props.callback(this.state.company_id);
      Middleware.Ui.Modal.close();
    }

    private onSelectHandler(event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>): void {
      this.setState({ [event.target.name]: event.target.value });
    }

    public render() {
      return (
        <>
          <div className="modal-background">
            <div className="modal modal--company-search">
              <div className="modal__header">
                <h2 className="modal__title">Поиск компании</h2>
                <div className="modal__desc">
                  Название компании может быть указано на русском или английском языке. Попробуйте
                  искать в двух вариантах.
                </div>
                <button
                  className="modal__close"
                  onClick={() => {
                    Middleware.Ui.Modal.close();
                  }}
                />
              </div>
              <form className="form" onSubmit={this.onSubmitHandler}>
                <div className="form__body">
                  <div className="form__group">
                    <InputAutocomplete
                      name="company_id"
                      type="company"
                      placeholder="Компания"
                      onSelect={this.onSelectHandler}
                      searchIcon={true}
                    />
                  </div>
                </div>
                <div className="form__footer">
                  <button
                    className={`btn ${this.state.company_id === null ? "btn--grey" : "btn--red"}`}
                    type="submit"
                    disabled={this.state.company_id === null}
                  >
                    Подтвердить
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      );
    }
  }
);
